import Loading from '../../components/layout/Loading'
import type { Event } from '../../../api/events/types'
import EventCard from '../../components/events/Card'
import { useI18N } from '../../../libraries/i18n/hook'
import SeeAllLink from '../../components/form/SeeAllLink'
import NoResults from '../../components/layout/NoResults'
import { useEvents } from './hooks'

const EVENTS_TO_SHOW = 3
const NextEvents = () => {
  const { t } = useI18N()
  const { data, isLoading } = useEvents(undefined, EVENTS_TO_SHOW)

  // Filter out past events
  const filteredEvents = data?.filter(event => new Date(event.endDate) > new Date())

  if(!data || isLoading) {
    return <Loading />
  }

  const areThereEventsToShow = () => {
    return filteredEvents && filteredEvents.length > 0
  }
  return (
    <div>
      <div className='flex justify-between items-center'>
        <h2 className='text-center'>{t('events.next')}</h2>
        <SeeAllLink label={t('events.seeAll')} linkTo='/events' />
      </div>
      {!areThereEventsToShow() && <NoResults className='mt-2 text-center' text={t('events.noEvents')} />}
      {areThereEventsToShow() && (
        <>
          <ul className='mt-4'>
            {filteredEvents?.map((event: Event) => (
              <li key={event.title} className='my-3'>
                <EventCard {...event} />
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}

export default NextEvents
